module.exports = __webpack_public_path__ + "images/application/templates/comment-notification@2x-580df9c1.png";